module.exports = __webpack_public_path__ + "static/img/guan5.54f5f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guan5.png
// module id = 8gjN
// module chunks = 36